import { Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ScriptLoadingService {
	scripts: Array<{ key: string; value: string }> = [];
	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	/**
	 * Append the JS tag to the Document Body.
	 * @param renderer The Angular Renderer
	 * @param src The path to the script
	 */
	loadJsScript(
		renderer: Renderer2,
		src?: string,
		data?: string,
		id?: string,
		async = true,
		dataDomainScript?: string
	): any {
		const script = renderer.createElement('script');
		script.type = 'text/javascript';
		script.async = async;
		script.id = id;
		if (data) {
			script.text = data;
		}
		if (src) {
			script.src = src;
		}
		if (dataDomainScript) {
			script.dataset.domainScript = dataDomainScript;
		}
		renderer.appendChild(this.document.head, script);
		this.scripts.push({ key: src, value: src });

		return script;
	}

	checkIfScriptExists(src: string): boolean {
		return this.scripts.some((script) => script.key === src);
	}
}
